import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import usePlans from "../hooks/use-plans";
import { Plan } from "../models/plan";

type Props = {
	selectedPlanId?: number;
	onSelect: (plan: Plan) => void;
};

export default function CompactPlanPicker({ selectedPlanId, onSelect }: Props) {
	const { plans } = usePlans();

	return (
		<div className="flex flex-col gap-2">
			{plans.map((plan, index) => {
				const isSelected = plan.id === selectedPlanId;
				const isRecommended = index === Math.floor(plans.length / 2);

				return (
					<button
						key={plan.id}
						type="button"
						onClick={() => onSelect(plan)}
						className={cn(
							"flex items-center justify-between gap-4 rounded-2xl border px-4 py-3 text-left transition-all",
							isSelected
								? "border-white bg-white text-blue-700"
								: "border-white/30 bg-white/10 text-white hover:bg-white/15"
						)}
					>
						<div className="flex flex-col">
							<div className="flex items-center gap-2">
								<span className="web-body-b1-medium">{plan.name}</span>
								{isRecommended && !isSelected && (
									<span className="rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide">
										Popular
									</span>
								)}
							</div>
							<span
								className={cn(
									"web-body-b3",
									isSelected ? "text-blue-700/70" : "text-white/70"
								)}
							>
								{plan.monthlyEntries} entries / month
							</span>
						</div>
						<div className="flex items-center gap-3">
							<div className="flex flex-col items-end">
								<span className="web-body-b1-medium">${plan.price}</span>
								<span
									className={cn(
										"text-[11px]",
										isSelected ? "text-blue-700/70" : "text-white/70"
									)}
								>
									/ month
								</span>
							</div>
							<div
								className={cn(
									"flex h-5 w-5 items-center justify-center rounded-full border",
									isSelected
										? "border-blue-700 bg-blue-700 text-white"
										: "border-white/50"
								)}
							>
								{isSelected && <Check size={14} strokeWidth={3} />}
							</div>
						</div>
					</button>
				);
			})}
		</div>
	);
}
